<script>
import Field from "@/components/input-v.vue";
import { FieldTypeEnum } from "@/core/enums/field-types";
import { toNumber } from "lodash";
import { mapGetters } from "vuex";

const createEmptyFormData = () => ({
  taxa_juros_anual: null
});

export default {
  components: {
    Field
  },
  data() {
    return {
      formData: createEmptyFormData(),
      originalData: createEmptyFormData()
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    actionBarButtons() {
      return [
        {
          text: "Atualizar",
          icon: "mdi-refresh",
          action: () => {
            this.doGetTax();
          }
        }
      ];
    },
    fields() {
      return [
        {
          key: "none",
          name:
            "Taxa de juros que será aplicada a todos os Business Plans que não tiverem uma taxa própria configurada.",
          type: FieldTypeEnum.SUBTITLE,
          colSize: 12
        },
        {
          key: "taxa_juros_anual",
          name: "Taxa de juros (%)",
          type: FieldTypeEnum.NUMBER,
          rules: [{ rule: "required" }],
          colSize: 1
        }
      ];
    },
    hasUnsavedChanges() {
      return (
        this.formData.taxa_juros_anual != this.originalData.taxa_juros_anual
      );
    },
    taxResource() {
      return this.apiResource(
        `/v1/ativacaoped/${this.clientId}/vpl-parametrizacao`
      );
    }
  },
  async created() {
    await this.doGetTax();
  },
  methods: {
    async doGetTax() {
      const response = await this.taxResource.get();
      this.formData.taxa_juros_anual = response.taxa_juros_anual;
      this.originalData.taxa_juros_anual = response.taxa_juros_anual;
    },
    async doSaveTax() {
      try {
        const invalid = this.fields.some(({ valid }) => !valid || !valid());

        if (invalid) {
          return;
        }

        const { taxa_juros_anual } = this.formData;
        await this.taxResource.save({
          taxa_juros_anual: toNumber(taxa_juros_anual)
        });
        await this.doGetTax();
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    }
  }
};
</script>

<template>
  <v-card :color="tableColor" elevation="0">
    <v-card-text class="d-flex">
      <div class="table-v-action-button mr-2" @click="doGetTax">
        <v-icon>mdi-refresh</v-icon>
        Atualizar
      </div>
    </v-card-text>

    <v-container fluid class="bg-white">
      <v-row class="pa-4">
        <Field
          v-for="field of fields"
          v-model="formData[field.key]"
          :colSize="field.colSize"
          :key="field.key"
          :label="field"
          :valid.sync="field.valid"
        />

        <v-col cols="12" class="button-container d-flex">
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            dark
            :disabled="!hasUnsavedChanges"
            depressed
            @click="doSaveTax"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style lang="scss" scoped>
.fields-container {
  height: 100%;
}

.button-container
  .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #272727 !important;
  opacity: 0.5;
}
</style>
